export const environment = {
  production: true,
  apiUrl: '/api',
  serviceUrl: '/service',
};
